module.exports = __webpack_public_path__ + "img/personla.69006680.png";